/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Src_2_DetailInputs */

const en_wb_management_src_2_detail = /** @type {(inputs: Wb_Management_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders with open exceptions`)
};

const lv_wb_management_src_2_detail = /** @type {(inputs: Wb_Management_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījumi ar atvērtiem izņēmumiem`)
};

/**
* | output |
* | --- |
* | "Orders with open exceptions" |
*
* @param {Wb_Management_Src_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_src_2_detail = /** @type {((inputs?: Wb_Management_Src_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Src_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_src_2_detail(inputs)
	return en_wb_management_src_2_detail(inputs)
});